import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';
import { GatewayDatosUsuarioResponse } from 'src/app/services/auth/gateway-auth.types';

/**
 * API Gateway: perfil / datos de usuario autenticado.
 * Legacy: parte de la respuesta del GET login con header Key.
 * Gateway: POST `/datos-usuario` con `Authorization: Bearer` (interceptor).
 */
@Injectable({ providedIn: 'root' })
export class TransportistaDatosUsuarioGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  fetch(
    options?: TransportistaGatewayPostOptions
  ): Observable<GatewayDatosUsuarioResponse> {
    return this.gw.post<GatewayDatosUsuarioResponse>(
      '/datos-usuario',
      {},
      options
    );
  }
}
